<mat-card style="border-color: #5775a8;">
  <mat-card-header>
    <div class="flex flex-row rounded-lg w-full">
      <div class="flex flex-row w-1/2">
        <!-- <mat-icon style="color: white;">open_in_new</mat-icon> -->
        <span style="font-size: x-large;color: #5775a8;font-weight: bold;">
          Complaint View
        </span>
      </div>
      <div class="flex flex-row w-1/2 justify-end">
        <button mat-raised-button (click)="gotoBusiness(currentComplaint.businessId)" class="m-8" style="background: #7ABDF3;">
          <mat-icon>open_in_new</mat-icon>
          Go to Business View
        </button>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <br />
    <mat-card>

      <div class="flex flex-col items-center w-full">
        <br />
        <div class="flex flex-row rounded-lg w-11/12">
          <table class="w-full">
            <tr style="padding-bottom: 10px;">
              <th>Complaint ID:</th>
              <td>{{currentComplaint.complaintId}} </td>
              <th>Complaint Status: </th>
              <td>
                {{currentComplaint.complaintStatus}}
                <br/>
                [<span *ngIf="currentComplaint.actionable">Actionable</span>
                <span *ngIf="!currentComplaint.actionable">Not Actionable</span>]
              </td>
            </tr>
            <tr>
              <th>Business:</th>
              <td>
                <span style="font-weight: bold;">{{currentComplaint.businessName}} </span>
                <br/>
                {{currentComplaint.address}} 
                <br/>
                {{currentComplaint.city}}, OR {{currentComplaint.zip}}
              </td>
              <th>Business Status:</th>
              <td>
                <span *ngIf="currentComplaint.businessActive" style="color: green;">Active</span>
                <span *ngIf="!currentComplaint.businessActive" style="color: red;">Inactive</span>
              </td>
            </tr>

          </table>

        </div>
        <br />
      </div>

    </mat-card>
    <mat-card>

    <mat-tab-group dynamicHeight [(selectedIndex)]="currentTab" (selectedTabChange)="tab()">

      <mat-tab label="Complaint Details">
        <complaint-complaintDetails></complaint-complaintDetails>
      </mat-tab>

      <mat-tab label="Files({{fileCount}})">
        <complaint-complaintFiles (refresh)="updateFiles()"></complaint-complaintFiles>
      </mat-tab>

      <mat-tab label="Business Details">
        <complaint-businessDetails [businessId]=""></complaint-businessDetails>
      </mat-tab>

      <mat-tab label="Correspondence">
        <shared-sharedCorrespondence [parentPanel]="0"></shared-sharedCorrespondence>
      </mat-tab>

      <mat-tab label="Site Visit">
        <shared-sharedSiteVisit  [parentPanel]="0"></shared-sharedSiteVisit>
      </mat-tab>

      <mat-tab label="Enclosed Area">
        <shared-sharedEnclosedArea [parentPanel]="0"></shared-sharedEnclosedArea>
      </mat-tab>

      <mat-tab label="Citations">
        <shared-sharedCitations [parentPanel]="0"></shared-sharedCitations>
      </mat-tab>

    </mat-tab-group> 

    </mat-card>
    <br />

  </mat-card-content>

</mat-card>